/* eslint-disable camelcase */
export enum SubscriptionStateType {
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed'
}

export enum SmsSubscriptionType {
  MARKETING = 'marketing',
  TRANSACTIONAL = 'transactional'
}

export enum CustomTrackEventType {
  INVITE_PARENT = 'Invite Parent'
}

export type SubscribeSMSType = {
  userId: string;
  subscriptionType: SmsSubscriptionType;
};

export type BrazeTrackRequestBodyType = {
  attributes: Array<{
    // eslint-disable-next-line camelcase
    external_id: string;
    // eslint-disable-next-line camelcase
    subscription_groups: Array<{
      // eslint-disable-next-line camelcase
      subscription_group_id: string;
      // eslint-disable-next-line camelcase
      subscription_state: SubscriptionStateType;
    }>;
  }>;
};

export type CustomEventType = {
  name: CustomTrackEventType;
  userAlias: {
    alias_name: string;
    alias_label: string;
  };
  properties?: any;
  appId: string;
};

export type BrazeUserAlias = {
  alias_name: string;
  alias_label: string;
};

export type BrazeTrackCustomEventType = {
  // One of "external_id" or "user_alias" or "braze_id" is required
  external_id?: string;
  user_alias?: BrazeUserAlias;
  braze_id?: string;
  // see App Identifier,
  app_id?: string;
  // the name of the event,
  name: string;
  // datetime as string in ISO 8601 or in `yyyy-MM-dd'T'HH:mm:ss:SSSZ` format),
  time: string;
  properties?: any;
  _update_existing_only: false;
};
